import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwRadioButtonComponent } from './cdw-radio-button/cdw-radio-button.component';
import { CdwRadioGroupComponent } from './cdw-radio-group/cdw-radio-group.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule],
  declarations: [CdwRadioButtonComponent, CdwRadioGroupComponent],
  exports: [CdwRadioButtonComponent, CdwRadioGroupComponent],
})
export class CdwRadioButtonModule {}
